import React from "react";

import Button from "components/common/Button";
import Tabs from "components/common/Tabs/Tabs";

import { ReactComponent as DownloadIcon } from "assets/svgs/download-icon.svg";
import { ReactComponent as PaperIcon } from "assets/svgs/paper-icon.svg";
import { ReactComponent as Paper02Icon } from "assets/svgs/paper02-icon.svg";
import { ReactComponent as PersonIcon } from "assets/svgs/person-icon.svg";
import { ReactComponent as TabletIcon } from "assets/svgs/tablet-icon.svg";
import { ReactComponent as DonationsIcon } from "assets/svgs/donations-icon.svg";
import { ReactComponent as BidsIcon } from "assets/svgs/bids-icon.svg";
import { ReactComponent as ContractsIcon } from "assets/svgs/contracts-icon.svg";

import * as S from "./SectionTransparency.Style";

const transparencyList = [
  {
    title: "Conformidade",
    image: PaperIcon,
    description: null,
    links: [
      {
        label: "Relatório anual de Conformidade (2025-2026)",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/Relatorio-Anual-da-Conformidade-2025-2026.pdf",
      },
      {
        label: "Relatório anual de Conformidade (2024-2025)",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/Relatório-Anual-de-Conformidade-2024-2025.pdf",
      },
      {
        label: "Relatório anual de Conformidade (2023-2024)",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/Relatorio-Anual-da-Conformidade-2023-2024.pdf",
      },
    ],
  },
  {
    title: "Financeiro",
    image: Paper02Icon,
    description: null,
    links: [
      {
        label:
          "26-02-26 - Balanço financeiro da CNP Seguros Holding Brasil (Exercício 2025)",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/balanco/balanco-patrimonial-cnp-2025.pdf",
      },
      {
        label:
          "11-03-25 - Balanço financeiro da CNP Seguros Holding Brasil (Exercício 2024)",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/balanco/balanco-patrimonial-cnp-2024.pdf",
      },
      {
        label:
          "28-02-24 - Balanço financeiro da CNP Seguros Holding Brasil (Exercício 2023)",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/balanco/balanco-patrimonial-cnp-2023.pdf",
      },
      {
        label:
          "28-02-23 - Balanço financeiro da CNP Seguros Holding Brasil (Exercício 2022)",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/balanco/balanco-patrimonial-cnp-2022.pdf",
      },
      {
        label:
          "12-05-22 - Balanço financeiro da CNP Seguros Holding Brasil (Exercício 2021) ",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/balanco/balanco-patrimonial-cnp-2021.pdf?_ga=2.246923532.92447727.1667843332-542798228.1660054478",
      },
    ],
  },
  {
    title: "Sustentabilidade",
    image: PersonIcon,
    description: null,
    links: [
      {
        label: "Relatório de Sustentabilidade 2025",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2025.pdf",
      },
      {
        label: "Relatório de Sustentabilidade 2024",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2024.pdf",
      },
      {
        label: "Relatório de Sustentabilidade 2023",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2023.pdf",
      },
      {
        label: "Relatório de Sustentabilidade 2022",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2022.pdf",
      },
      {
        label: "Relatório de Sustentabilidade 2021",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2021.pdf",
      },
      {
        label: "Relatório de Sustentabilidade 2020 ",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-Caixa-Seguradora-2020.pdf?utm_medium=canais-proprios&utm_source=area-aberta&utm_campaign=site-cnp&utm_term=ae378&utm_content=corporativo-relatorio-de-sustentabilidade-cs-2020",
      },
    ],
  },
  {
    title: "Ouvidoria",
    image: TabletIcon,
    description: null,
    links: [
      {
        label: "Relatório de Ouvidoria do segundo semestre de 2024 ",
        href: "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/ouvidoria/relatorio-de-ouvidoria-segundo-semestre-2024.pdf",
      },
    ],
  },
  {
    title: "Doações",
    image: DonationsIcon,
    description: (
      <>
        <S.TransparencyItemText>
          A CNP Seguros Holding Brasil não efetua doações diretamente. No
          entanto, nossas subsidiárias têm autonomia para efetuá-las, desde que
          respeitem a Política de Doações e outros documentos que previnam
          possíveis práticas de corrupção e lavagem de dinheiro.
        </S.TransparencyItemText>

        <S.TransparencyItemText>
          As doações são conduzidas com transparência e podem ser verificadas em
          nosso Relatório de Sustentabilidade.
        </S.TransparencyItemText>

        <S.TransparencyItemText>
          Reafirmamos o compromisso com a conformidade, ética e
          sustentabilidade, garantindo que todas as ações estejam alinhadas com
          os padrões de integridade e responsabilidade social.
        </S.TransparencyItemText>
      </>
    ),
    links: null,
  },
  {
    title: "Licitações",
    image: BidsIcon,
    description: (
      <>
        <S.TransparencyItemText>
          Até o momento, não participamos de licitações com a administração
          pública. Porém, a empresa está autorizada e preparada para atuar em
          futuros processos, com base na Lei nº 14.133/2021, que regulamenta as
          licitações e os contratos administrativos no Brasil.
        </S.TransparencyItemText>

        <S.TransparencyItemText>
          Reforçamos o nosso compromisso com a transparência e a conformidade
          legal, estando sempre à disposição para atender às exigências e
          requisitos estabelecidos pelas leis atuais.
        </S.TransparencyItemText>
      </>
    ),
    links: null,
  },
  {
    title: "Relações Governamentais",
    image: ContractsIcon,
    description: (
      <>
        <S.TransparencyItemText>
          <strong>Empresa Brasileira de Correios e Telégrafos (ECT)</strong>
          <br />
          Posição da Companhia: Contratante <br /> Finalidade: Prestação pela
          ECT de serviços e venda de produtos como: cartas, telegramas, Sedex,
          malotes, entre outros
        </S.TransparencyItemText>

        <S.TransparencyItemText>
          <strong>
            Caixa Econômica Federal: Seguro Patrimonial (feito por consulta
            pública)
          </strong>
          <br />
          Posição da Companhia: Contratada <br />
          Finalidade: Assegurar a cobertura securitária das instalações físicas
          da CAIXA, abrangendo aproximadamente 4.300 imóveis, com o objetivo de
          garantir suporte adequado às operações do Banco e às demandas das
          unidades correlatas, como as equipes de Engenharia e Infraestrutura.
        </S.TransparencyItemText>

        <S.TransparencyItemText>
          <strong>
            Caixa Econômica Federal: Seguro Terminais Financeiros Lotéricos
            (feito por consulta pública)
          </strong>
          <br />
          Posição da Companhia: Contratada
          <br /> Finalidade: Garantir cobertura securitária para os
          equipamentos, instalados nas Unidades Lotéricas, Unidades Móveis ou em
          locais de guarda sob responsabilidade da CAIXA, em todo o território
          nacional. Atualmente nossos serviços cobrem mais de 49 mil
          equipamentos e periféricos.
        </S.TransparencyItemText>
      </>
    ),
    links: null,
  },
];

const SectionTransparency = () => {
  return (
    <S.SectionTransparencyContainer>
      <S.SectionTransparencyContent className="container">
        <S.SectionTransparencyBlock>
          <S.SectionTransparencyTitle>Transparência</S.SectionTransparencyTitle>

          <S.SectionTransparencyDescription>
            Acreditamos que compartilhar nossos resultados de forma transparente
            e acessível é agir com responsabilidade e ética, o que fortalece
            ainda mais nossa relação com parceiros, clientes e colaboradores.{" "}
            <strong>Neste espaço</strong>, você pode conferir relatórios e{" "}
            <strong>balanços financeiros</strong>, além de ter detalhes sobre
            licitações, doações e contratos. Agora, se quiser saber sobre{" "}
            <strong>
              <a href="/patrocinios">patrocínio, clique aqui</a>
            </strong>{" "}
            que a gente encaminha você para uma página exclusiva sobre esse
            assunto.
          </S.SectionTransparencyDescription>
        </S.SectionTransparencyBlock>

        <Tabs
          defaultIndex={0}
          tabs={transparencyList.map((transparencyItem) => ({
            ...transparencyItem,
            content: (
              <S.TransparencyItemContainer>
                <transparencyItem.image />

                <S.TransparencyItemContent>
                  {transparencyItem?.description
                    ? transparencyItem.description
                    : null}

                  {Array.isArray(transparencyItem?.links)
                    ? transparencyItem?.links?.map((linkItem, index) => (
                        <Button
                          key={index}
                          as="a"
                          size="lg"
                          href={linkItem.href}
                          target="_blank"
                        >
                          <DownloadIcon /> <span>{linkItem?.label}</span>
                        </Button>
                      ))
                    : null}
                </S.TransparencyItemContent>
              </S.TransparencyItemContainer>
            ),
          }))}
        />
      </S.SectionTransparencyContent>
    </S.SectionTransparencyContainer>
  );
};

export default SectionTransparency;
